import React from "react";
import { ManageReferralProgramsComponent } from "../../../components/manage-referral-programs-components/ManageReferralProgramsComponent";

export const ReferralProgramsContainer: React.FC = () => {
  return <ManageReferralProgramsComponent />;
};
